import type { EntryInput, EntryType, MyTimesheetDTO } from "@contractorhub/shared";

/**
 * One project's view of one week, as the editor holds it.
 *
 * The API returns a `MyTimesheetDTO` per project per week; the editor keeps one
 * `Row` per assignment and edits `entries` in place. The intersection is only
 * there to pin `entries` as mutable-by-us rather than the DTO's own array.
 */
export type Row = MyTimesheetDTO & { entries: EntryInput[] };

export type SaveState = "idle" | "unsaved" | "saving" | "saved" | "error";
export type PendingAction = "save" | "submit";
export type DayDetailMode = "note" | "type";

/**
 * What a day is before anybody says otherwise: worked on a weekday, non-working
 * on a weekend. The same rule `defaultEntries` seeds a fresh week with, which is
 * why "clear this day" and "the API's untouched week" agree.
 */
export function defaultTypeForDay(day: number): EntryType {
  return day >= 5 ? "NON_WORKING" : "WORKED";
}
